<template>
  <div v-if="$can('set', 'useClassificationTemplates')">
    <sPopover
      v-model="showMenu"
      :disabled="disableMenu"
      placement="bottom-start"
      :style-root="'margin: auto;'"
      style-wrapper="display: flex;"
      trigger="click">
      <sButton
        slot="reference"
        class="px-2 mt-2 mr-0 ml-auto"
        :disabled="disableMenu"
        small
        type="text">
        {{ $t('Tenders.CategoryTemplate') }}
        <sIcon
          class="ml-2 my-auto"
          :rotate="showMenu ? '-180' : '0'"
          size="10"
          :spin="loading"
          :type="loading ? 'loading' : 'arrow'"/>
      </sButton>
      <div>
        <div
          v-if="categoryTemplates && categoryTemplates.length"
          class="category-tamplate__rows">
          <MenuItem
            v-for="(tempateItem, templateIndex) in categoryTemplates"
            :key="templateIndex"
            :disabled="loading"
            @click="setTemplate(tempateItem)">
            <div
              slot="content"
              class="category-tamplate__row"
              data-qa="filters-template-actions">
              <div class="category-tamplate__row-label">
                <sIcon
                  v-if="currentTemplateId === tempateItem.id"
                  class="mr-1"
                  size="10"
                  type="okay-arrow"/>
                {{ tempateItem.title }}
              </div>
              <div
                class="category-tamplate__row-btn">
                <sButton
                  v-if="!tempateItem.locked"
                  data-qa="btn-edit-filter"
                  icon="edit"
                  small
                  type="text"
                  @click.stop="openModal(tempateItem)"/>
                <sButton
                  v-if="!tempateItem.locked"
                  data-qa="btn-delete-filter"
                  icon="delete"
                  small
                  type="text"
                  @click.stop="deleteTempate(tempateItem)"/>
              </div>
            </div>
          </MenuItem>
        </div>
        <sDivider
          v-if="categoryTemplates && categoryTemplates.length"
          class="my-2 mx-2"/>
        <MenuItem
          :disabled="loading || !!currentTemplateId || !hasCategory"
          icon="file-add"
          :label="$t('Tenders.CategoryTemplateSaveTemplate')"
          @click="openModal()"/>
      </div>
    </sPopover>
    <sModal
      v-model="modal.show"
      :title="modal.data && modal.data.id ? $t('Tenders.CategoryTemplateEdit') : $t('Tenders.CategoryTemplateAdd')">
      <template v-if="modal.data">
        <sForm
          ref="categoryTemplateForm"
          class="mt-5"
          :disabled="modal.loading"
          label-position="top"
          :model="modal.data"
          :rules="rules">
          <div class="block-template">
            <sFormItem
              :label="$t('Tenders.CategoryTemplateMain')"
              prop="mainCategory.code">
              <sInput
                :max-rows="2"
                readonly
                rows="1"
                type="textarea"
                :value="modal.data.mainCategory.title || ''"/>
            </sFormItem>
            <template v-if="modal.data.additionalCategories && modal.data.additionalCategories.length">
              <div class="block-template__additional-label">
                {{ `${$t('Tenders.CategoryTemplateAdditional')}:` }}
              </div>
              <div class="block-template__additional-items">
                <sTooltip
                  v-for="(additionalCategorie, additionalCategorieIndex) in modal.data.additionalCategories"
                  :key="`${additionalCategorie.code}_${additionalCategorieIndex}`"
                  :border="false"
                  :content="additionalCategorie.title"
                  :enterable="false"
                  type="white">
                  <sChip
                    background="#B1BBBB"
                    class="my-1 mr-2"
                    color="black"
                    style="max-width: 270px;">
                    {{ additionalCategorie.title }}
                    <div
                      slot="after"
                      class="ml-1 pointer my-auto"
                      @click="deleteAdditionalCategorie(additionalCategorie.code)">
                      <sIcon
                        color="black"
                        size="8"
                        type="cross"/>
                    </div>
                  </sChip>
                </sTooltip>
              </div>
            </template>
          </div>
          <sFormItem
            class="mt-2"
            :label="$t('Tenders.CategoryTemplateName')"
            prop="title">
            <sInput
              clearable
              :max-length="4000"
              :value.sync="modal.data.title"/>
          </sFormItem>
        </sForm>
      </template>
      <div
        key="footer"
        slot="footer">
        <sButton
          data-qa="btn-apply"
          :disabled="loading || modal.loading"
          @click="saveTemplate">
          {{ $t('Common.Save') }}
        </sButton>
        <sButton
          data-qa="btn-close"
          :disabled="loading || modal.loading"
          type="text"
          @click="closeModal">
          {{ $t('Common.Cancel') }}
        </sButton>
      </div>
    </sModal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import MenuItem from 'components/common/MenuItem.vue'

import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

/*const tempalteCategory = {
  id: null,
  locked: false,
  title: null,
  mainCategory: {},
  additionalCategories: []
}*/

export default {
  name: 'CategoryTemplate',
  data() {
    const that = this
    return {
      loading: true,
      showMenu: false,
      currentTemplateId: null,
      categoryTemplates: [],
      modal: {
        show: false,
        data: null,
        loading: false,
      },
      rules: {
        title: [
          {
            type: 'string',
            trigger: 'change',
            transform(value) {
              return value?.trim()
            },
            required: true,
            message: that.$t('Validate.Required')
            //message: that.$t('Tenders.CategoryTemplateTitleValidMessage')
          },
          {
            type: 'string',
            trigger: 'change',
            min: 2,
            message: that.$t('Validate.minLength', {number: 2, type: that.$tc('Common.characters', 2) })
          },
          {
            type: 'string',
            required: true,
            trigger: 'change',
            max: 4000,
            message: that.$t('Validate.maxLength', {number: 4000, type: that.$tc('Common.characters', 10) })
          }
        ],
        'mainCategory.code': {
          type: 'string',
          trigger: 'change',
          required: true,
          transform(value) {
            return value?.trim()
          },
          message: that.$t('Tenders.CategoryTemplateTitleValidMessage')
        }
      }
    }
  },
  methods: {
    deleteAdditionalCategorie(code) {
      if (this.modal.loading) {
        return
      }
      const itemIndex = this.modal.data.additionalCategories.findIndex(i => i.code === code)
      return this.modal.data.additionalCategories.splice(itemIndex, 1)
    },
    saveTemplate() {
      this.$refs.categoryTemplateForm.validate(async (valid) => {
        if (!valid) {
          return
        }
        this.modal.loading = true
        const data = {
          title: this.modal.data.title,
          categoryCode: this.modal.data.mainCategory.code,
          additionalCategoryCodes: this.modal.data.additionalCategories?.map(i => i.code) || []
        }
        let endpoint = 'createCategoryTemplate'
        if (this.modal.data.id) {
          endpoint = 'updateCategoryTemplate'
          data.id = this.modal.data.id
        }
        api[endpoint](data)
          .then((result) => {
            if (result) {
              this.getCategoryTemplate()
              this.modal.show = false
            }
          })
          .finally(() => {
            this.modal.loading = false
          })
      })
    },
    checkCurrentTemplateId() {
      if (this.value?.mainCategory) {
        const templatesByMain = this.categoryTemplates.filter(i => i.mainCategory.code === this.value?.mainCategory)
        if (!templatesByMain?.length) {
          this.currentTemplateId = null
          return
        }
        const value = this.$_.cloneDeep(this.value)
        const additionalCodes = JSON.stringify(value.additionalCategories.sort((a, b) => a?.localeCompare(b)) || '')
        this.currentTemplateId = templatesByMain.find(i => JSON.stringify(i.additionalCategorieCodes) === additionalCodes)?.id
        return
      }
      this.currentTemplateId = null
      return
    },
    closeModal() {
      this.modal.show = false
      this.modal.data = null
    },
    openModal(dataItem) {
      this.showMenu = false
      if (!dataItem) {
        dataItem = this.$_.cloneDeep(this.curentValue)
        dataItem.id = null
        dataItem.title = null
        dataItem.locked = false
      }
      this.modal.data = this.$_.cloneDeep(dataItem)
      this.modal.show = true
    },
    setTemplate(object) {
      if (this.currentTemplateId === object.id) {
        return
      }
      this.$emit('update:value', object)
    },
    deleteTempate(item) {
      this.loading = true
      api.deleteCategoryTemplate(item.id)
        .then((result) => {
          if (result) {
            const indexToRemove = this.categoryTemplates.findIndex(ш => ш.id === item.id)
            if (indexToRemove !== -1) {
              this.categoryTemplates.splice(indexToRemove, 1)
              this.showMenu = false
            }
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    getCategoryTemplate() {
      this.loading = true
      this.categoryTemplates = []
      api.getCategoryTemplates()
        .then(response => {
          const getCategoryMode = (item) => {
            if (!item) {
              return item
            }
            return {
              code: item.code,
              title: item.title,
            }
          }
          response = response.map(i => {
            const additionalCategories = i.additionalCategories?.length
              ? i.additionalCategories
                .sort((a, b) => a.code?.localeCompare(b.code))
                .map(i => getCategoryMode(i))
              : []
            return {
              id: i.id,
              title: i.title,
              locked: i.locked,
              mainCategory: getCategoryMode(i.mainCategory),
              additionalCategories: additionalCategories,
              additionalCategorieCodes: additionalCategories.map(i => i.code)
            }
          })
          const getTitle = (item) => {
            return `${item.code} ${item.title}`
          }
          response?.forEach(responseItem => {
            responseItem.mainCategory.title = getTitle(responseItem.mainCategory)
            responseItem.additionalCategories?.forEach(additionalCategoriesItem => {
              additionalCategoriesItem.title = getTitle(additionalCategoriesItem)
            })
            this.categoryTemplates.push(responseItem)
          })
          this.checkCurrentTemplateId()
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  computed: {
    ...mapGetters({
      currentOrganization: 'getCurrentOrganization',
    }),
    hasCategory() {
      return !!this.curentValue?.additionalCategories?.length || !!this.curentValue?.mainCategory?.code
    },
    disableMenu() {
      if (this.disabled) {
        return true
      }
      return !this.value?.mainCategory
    }
  },
  components: {
    MenuItem
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (!oldValue || JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          this.checkCurrentTemplateId()
        }
      }
    },
    'currentOrganization.organizationItId': {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (!oldValue || newValue !== oldValue ) {
          this.getCategoryTemplate()
        }
      }
    }
  },
  created() {
  },
  props: {
    value: {
      type: Object
    },
    curentValue: {
      type: Object
    },
    disabled: {
      type: Boolean
    }
  },
}
</script>
<style scoped lang="scss">
.category-tamplate {
  &__rows {
    max-height: 300px;
    width: 100%;
    overflow: auto;
  }
  &__row {
    $row: &;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 60px;
    &-label {
      margin: auto auto auto 0;
      max-width: 200px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    &-btn {
      opacity: 0;
    }
    &:hover,
    &:focus {
      #{$row}-btn {
        opacity: 1;
      }
    }
  }
}
.block-template {
  border-radius: 8px;
  background: var(--green_chosen_light);
  padding: 14px 12px;
  &__main-label,
  &__additional-label {
    font-size: 12px;
    line-height: 16px;
    padding-left: 17px;
    margin-top: 6px;
  }
  &__additional-items {
    display: flex;
    flex-wrap: wrap;
    max-height: 300px;
    overflow: auto;
  }
  /*&__additional-item {
    color: #000;
    font-size: 14px;
    border-radius: 100px;
    background: #B1BBBB;
    padding: 1px 20px 1px 8px;
    margin: 0 auto 0 0;
    margin: 3px 0;
    max-width: 100%;
  }*/
}
</style>
